









import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import AnalyticsCardList, {
  AnalyticsCardListItem
} from '@/componentsV2/organisms/AnalyticsCardList/AnalyticsCardList.vue';

@Component({
  components: {
    AnalyticsCardList
  }
})
export default class CampaignStatistics extends Vue {
  @Prop({ default: () => [] }) statistics!: AnalyticsCardListItem[];
}
